export class BundleDeleteService {
    constructor($stateParams, JFrogModal, BundlesDao, JFrogNotifications) {
        this.$stateParams = $stateParams;
        this.artifactoryModal = JFrogModal;
        this.BundlesDao = BundlesDao;
        this.notifications = JFrogNotifications;
    }
    deleteBundleVersion(bundleName, bundleVersion, onSuccessCb) {
        this.artifactoryModal.confirm(
                `Are you sure you want to delete version ${bundleVersion} of the ${bundleName} release bundle?`,
                `Delete Release Bundle`)
                .then(() => {
                    this.BundlesDao.deleteBundles({
                        type: this.$stateParams.type,
                        name: bundleName,
                        version: bundleVersion
                    }).$promise.then(() => {
                        if(onSuccessCb && typeof onSuccessCb === 'function') {
                            onSuccessCb();
                        }
                        this.notifications.create({
                            info: `You successfully removed version ${bundleVersion} from ${bundleName} bundle`
                        });
                    }).catch((response) => {
                        // TODO: Rephrase with product
                        this.notifications.create({
                            error: `Version ${bundleVersion} from ${bundleName} bundle could not be removed.`
                        });
                    });
                });
    }
}

BundleDeleteService.META = {
    name: 'BundleDeleteService'
};



// WEBPACK FOOTER //
// ./states/bundles/services/bundle.delete.service.js